module.exports = __webpack_public_path__ + "images/store_case_study/wink-pic1_d23a1f736fdd8a35250738ef7746c76d.png";